.container {
  height: 100%;

  display: flex;
  flex-direction: column;
}

.input {
  flex: 1 1 0px;
  overflow: hidden;
}

.status {
  flex: 0 0 auto;
}
